import ContentRenderer, { TContent } from "../content-renderer/content-renderer";
import styles from "./article-body.module.less";

export type TArticleBodyProps = {
  preamble?: string;
  body: string;
  sideComponent?: React.ReactNode;
  jsonContent?: TContent;
};

export const ArticleBody = ({ preamble, body, sideComponent, jsonContent }: TArticleBodyProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={[styles.innerWrapper, "max-width padded-sides"].join(" ")}>
        <div className={`${styles.textWrapper} text-max-width`}>
          {preamble && <p className={[styles.preamble, "body-l bold"].join(" ")}>{preamble}</p>}
          {jsonContent ? (
            <ContentRenderer content={jsonContent} className={styles.content} />
          ) : (
            <div className={[styles.content, "html-content"].join(" ")} dangerouslySetInnerHTML={{ __html: body }} />
          )}
        </div>
        {sideComponent && <div className={styles.sideComponentWrapper}>{sideComponent}</div>}
      </div>
    </div>
  );
};

export default ArticleBody;
